$(document).ready(function($){
    $('.myBtnProductInfo').click(function(){
        $('#modalProductInfo').css('display', 'block');
    });

    $('#close-modal-product-info').click(function(){
        $('#modalProductInfo').css('display', 'none');
    });

    window.onclick = function(event) {
        if (event.target.id == 'modalProductInfo') {
            // modal.style.display = "none";
            $('#modalProductInfo').css('display', 'none');
        }
    }

});